import React from 'react'

export const IconEdit = (props = {}) => {
	const {size = 20, imgSize= 20, fill = "white"} = props
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path
				d="M17.1549 3.82104L16.1784 2.84454C15.7093 2.37628 15.0737 2.11328 14.4108 2.11328C13.748 2.11328 13.1123 2.37628 12.6432 2.84454L2.5 12.9877V17.4994H7.01175L17.1549 7.35621C17.6232 6.88713 17.8862 6.25141 17.8862 5.58862C17.8862 4.92582 17.6232 4.29011 17.1549 3.82104ZM6.49392 16.2494H3.75V13.5055L11.5195 5.73604L14.2634 8.47993L6.49392 16.2494ZM16.2711 6.47237L15.1472 7.59621L12.4032 4.85229L13.5271 3.72837C13.7618 3.49456 14.0795 3.36329 14.4107 3.36329C14.7421 3.36329 15.0598 3.49456 15.2945 3.72837L16.2712 4.70512C16.505 4.93979 16.6362 5.25752 16.6362 5.58875C16.6362 5.91997 16.5048 6.23771 16.2711 6.47237Z"
				fill={fill}
			/>
		</svg>
	</>
}
